import GuideIcon from './GuideIcon.svg';

export default {
  GuideIcon,
};
